export default class GenerateWhatsAppProtocolIdUseCase {
  public execute() {
    const currentDate = new Date();
    return currentDate.toISOString().replaceAll(/[^0-9]/g, '');
  }
}
